export enum EnvironmentConfiguration {
	dev = 'dev',
	staging = 'staging',
	production = 'production'
}
